import styled from 'styled-components';

import { TextStyledProps } from './types';

export const TextStyled = styled.p<TextStyledProps>`
  margin: 0;

  ${({ variant, theme }) => {
    switch (variant) {
      case 'badge-archived': {
        return `
        ${theme.typography.caption};
        color: ${theme.colors.neutral.backgroundVariant};
        `;
      }
      case 'event':
      case 'learning':
        return `
        ${theme.typography.body3};
        color: ${theme.colors.neutral.onBackground};
        `;
      case 'meta':
        return `
        ${theme.typography.body3};
        color: ${theme.colors.neutral.onContainer};
        flex: 0 1 auto;
        min-width: 0;
        text-overflow: ellipsis;
        text-wrap: nowrap;
        overflow: hidden;
        `;
      default:
        return `
        ${theme.typography.caption};
        color: ${theme.colors.neutral.onBackground};
        `;
    }
  }}
`;
